import { useFind } from 'api/APIHooks';
import { useCurrentProviderId } from 'common/contexts/CurrentProviderContext';

const useAssignedToOptions = () => {
  const providerId = useCurrentProviderId();
  let assignedToOptions = [];
  const { isSuccess: isAssignedToSuccess, data: assignedToData } = useFind(
    'employee',
    { provider: providerId },
    {
      queryConfig: {
        enabled: !!providerId,
        placeholderData: undefined,
      },
      page: {
        size: Infinity,
      },
    },
  );

  if (isAssignedToSuccess) {
    const employees = assignedToData.data.data;
    assignedToOptions = employees.map((employee) => ({
      label: employee.full_name,
      value: employee.id,
    }));
  }

  assignedToOptions.unshift({
    label: 'Unassigned',
    value: 'unassigned',
  });

  return assignedToOptions;
};

export default useAssignedToOptions;
